import PropTypes from 'prop-types';
import React, { useCallback, memo, useMemo } from 'react';
import _ from 'underscore';
import { LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { Select } from '@bingads-webui-react/primitive-with-signal';
import { i18nPropType } from '../shapes';

export const CountryInputUnMemo = ({
  i18n,
  countryOptions,
  country,
  setCountry,
  setPiid,
  helpPopUpId,
  helpPopUpAriaLabel,
}) => {
  const mappedCountryList = useMemo(
    () => _.map(countryOptions, c => ({
      id: c.Code,
      value: c.Name,
    })),
    [countryOptions]
  );

  const selectOptions = useMemo(
    () => mappedCountryList.map(({ id, value }) => <option key={id} value={id}>{value}</option>),
    [mappedCountryList]
  );

  return (
    <LineByLineFormGroup
      label={i18n.getString(_TL_('Billing country/region'))}
      helpPopupTopic={helpPopUpId}
      helpPopupAriaLabel={helpPopUpAriaLabel || i18n.getString(_TL_('Billing country / region tooltip'))}
    >
      <Select
        value={country}
        name="pi country"
        aria-label={i18n.getString(_TL_('Billing country / region dropdown'))}
        onChange={useCallback(
          ({
            target: { value: newValue },
          }) => {
            setCountry(newValue);
            // if changing the country, from the pi's country, we should unset the pi
            setPiid(null);
          },
          [setCountry, setPiid]
        )}
      >
        {selectOptions}
      </Select>
    </LineByLineFormGroup>
  );
};

CountryInputUnMemo.displayName = 'CountryInput';
CountryInputUnMemo.propTypes = {
  i18n: i18nPropType.isRequired,
  countryOptions: PropTypes.arrayOf(PropTypes.shape({
    Code: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
  })).isRequired,
  country: PropTypes.string.isRequired,
  setCountry: PropTypes.func.isRequired,
  setPiid: PropTypes.func.isRequired,
  helpPopUpId: PropTypes.string,
  helpPopUpAriaLabel: PropTypes.string,
};

CountryInputUnMemo.defaultProps = {
  helpPopUpId: 'Pop_BA_PaymentMethods_Index_AddCard_Country',
  helpPopUpAriaLabel: null,
};


export const CountryInput = memo(CountryInputUnMemo);
